import { supabase } from './supabaseClient';
import { montoParaBD } from '../utils/validacion';

import { getNegocioId } from './negocioActual';

// Cuentas por cobrar (fiado). Trae el nombre del cliente.
export async function obtenerPorCobrar({ soloPendientes = true } = {}) {
  let query = supabase
    .from('cuentas_por_cobrar')
    .select('*, clientes ( nombre, telefono )')
    .eq('negocio_id', getNegocioId())
    .order('fecha', { ascending: true });
  if (soloPendientes) query = query.eq('estado', 'pendiente');
  const { data, error } = await query;
  if (error) throw error;
  return data || [];
}

// Registra un abono (pago) hacia una cuenta por cobrar: acredita la cuenta
// y reduce el saldo; si se salda, queda 'pagada'.
export async function registrarAbono({ cxcId, monto, cuentaId }) {
  const { error } = await supabase.rpc('registrar_abono', {
    p_negocio_id: getNegocioId(),
    p_cxc_id: cxcId,
    p_monto: montoParaBD(monto, { nombre: 'monto del abono' }),
    p_cuenta_id: cuentaId || null,
  });
  if (error) throw error;
}

// Un abono por id (para precargar el editor).
export async function obtenerAbono(id) {
  const { data, error } = await supabase
    .from('abonos').select('*').eq('negocio_id', getNegocioId()).eq('id', id).single();
  if (error) throw error;
  return data;
}

// Edita un abono (monto, cuenta y/o fecha) con reverso atómico del dinero.
export async function editarAbono(id, { monto, cuentaId, fecha }) {
  const { error } = await supabase.rpc('editar_abono', {
    p_negocio_id: getNegocioId(),
    p_abono_id: id,
    p_monto: montoParaBD(monto, { nombre: 'monto del abono' }),
    p_cuenta_id: cuentaId || null,
    p_fecha: fecha || null,
  });
  if (error) throw error;
}

// Elimina un abono (pago) suelto con reverso del dinero.
export async function eliminarAbono(id) {
  const { error } = await supabase.rpc('eliminar_abono', {
    p_negocio_id: getNegocioId(),
    p_abono_id: id,
  });
  if (error) throw error;
}

// La cuenta por cobrar (venta a crédito) a la que pertenece un abono.
export async function obtenerCxcDeAbono(abonoId) {
  const neg = getNegocioId();
  const { data: ab, error: e1 } = await supabase
    .from('abonos').select('cxc_id').eq('negocio_id', neg).eq('id', abonoId).single();
  if (e1) throw e1;
  const { data: cxc, error } = await supabase
    .from('cuentas_por_cobrar').select('*').eq('negocio_id', neg).eq('id', ab.cxc_id).single();
  if (error) throw error;
  return cxc;
}

// Abonos (pagos) de una cuenta por cobrar, para verlos y editarlos.
export async function obtenerAbonosDeCxc(cxcId) {
  const { data, error } = await supabase
    .from('abonos').select('*').eq('negocio_id', getNegocioId()).eq('cxc_id', cxcId)
    .order('creado_en', { ascending: true });
  if (error) throw error;
  return data || [];
}

// Edita TODO de una venta a crédito (items, cliente, canal, fecha, descuento,
// concepto, nota, envío) preservando los abonos ya hechos.
export async function editarVentaCredito(referencia, { items, clienteId, descuento, concepto, nota, canal, fecha, envio }) {
  const { data, error } = await supabase.rpc('editar_venta_credito', {
    p_negocio_id: getNegocioId(),
    p_referencia: String(referencia),
    p_items: items.map((i) => ({ producto_id: i.producto_id, cantidad: i.cantidad, descuento: i.descuento || 0 })),
    p_cliente_id: clienteId || null,
    p_descuento: parseFloat(descuento) || 0,
    p_concepto: concepto?.trim() || null,
    p_nota: nota?.trim() || null,
    p_canal: canal || null,
    p_fecha: fecha || null,
    p_envio: parseFloat(envio) || 0,
  });
  if (error) throw error;
  return data;
}
